import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/home/Navbar.jsx';
import FooterSection from '../components/home/FooterSection.jsx';

const MainLayout = () => (
  <div className="min-h-screen flex flex-col">
    <Navbar />
    <main className="flex-1">
      <Outlet />
    </main>
    <FooterSection />
  </div>
);

export default MainLayout;
